

function FooterBar() {
    return (
        <div className={"footer-bar"}>
            This website was built by Ben Gelinas using React and Bootstrap
        </div>
    )
}
export default FooterBar